import { render, staticRenderFns } from "./BusinessCarousel.vue?vue&type=template&id=0fad20d6&"
import script from "./BusinessCarousel.vue?vue&type=script&lang=js&"
export * from "./BusinessCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports